<h2 mat-dialog-title>{{ 'DOMAIN_AUTHORIZATION.SENDER_INFO_FORM.FORWARDING_ADDRESS_INFO_TITLE' | translate }}</h2>
<mat-dialog-content>
  <div [innerHTML]="'DOMAIN_AUTHORIZATION.SENDER_INFO_FORM.FORWARDING_ADDRESS_INFO' | translate"></div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close mat-stroked-button>
    {{ 'DOMAIN_AUTHORIZATION.SENDER_INFO_FORM.CLOSE_BUTTON' | translate }}
  </button>
</mat-dialog-actions>
